import _ from 'underscore';
import { STREAMSERVE_EVENTS } from '../../modules/streamserve_events.js';

angular.module('vastdesk').controller('DemandTagServerSideTableController', ['$scope', function ($scope) {
  $scope.demandTagBulkActionDisabledConditions = {
    onlyProgrammaticGuaranteedSelected: false,
  };

  function syncProgrammaticGuaranteedCreateUrl(event) {
    const url = event?.detail?.url ?? null;

    if ($scope.programmaticGuaranteedCreateUrl === url) {
      return;
    }

    $scope.$evalAsync(function () {
      $scope.programmaticGuaranteedCreateUrl = url;
    });
  }

  document.addEventListener(STREAMSERVE_EVENTS.STREAMING_CONTEXT_CHANGE, syncProgrammaticGuaranteedCreateUrl);
  document.dispatchEvent(new CustomEvent(STREAMSERVE_EVENTS.STREAMING_CONTEXT_REQUEST));
  $scope.$on('$destroy', function () {
    document.removeEventListener(STREAMSERVE_EVENTS.STREAMING_CONTEXT_CHANGE, syncProgrammaticGuaranteedCreateUrl);
  });

  const serverSideTable = $('#demand_tags_table');
  let allProgrammaticGuaranteedTagIds = [];

  serverSideTable.on('xhr.dt', function(e, settings, json, xhr) {
    if (json && json.custom_data && json.custom_data.programmatic_guaranteed_tag_ids) {
      allProgrammaticGuaranteedTagIds = json.custom_data.programmatic_guaranteed_tag_ids;
    }
  });

  $scope.$watchCollection('selectedDemandTagBulkActionIds', function (new_val, old_val) {
    if (!Array.isArray(new_val) || !Array.isArray(allProgrammaticGuaranteedTagIds)) {
      return;
    }

    $scope.demandTagBulkActionDisabledConditions.onlyProgrammaticGuaranteedSelected = _.difference(new_val, allProgrammaticGuaranteedTagIds).length === 0;
  });
}]);
